export default __webpack_public_path__ + "static/media/Wildcard_common.d47880cd.png";